var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6669 18.5557H8C6.61929 18.5557 5.5 17.4364 5.5 16.0557V8C5.5 6.61929 6.61929 5.5 8 5.5H16.6669C18.0476 5.5 19.1669 6.61929 19.1669 8V16.0557C19.1669 17.4364 18.0476 18.5557 16.6669 18.5557Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44434 14.1666H8.88881C9.4411 14.1666 9.88881 13.7189 9.88881 13.1666V8.44431C9.88881 7.89202 9.4411 7.44431 8.88881 7.44431H8.44434C7.89205 7.44431 7.44434 7.89202 7.44434 8.44431V13.1666C7.44434 13.7189 7.89205 14.1666 8.44434 14.1666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1116 12.3333H12.556C13.1083 12.3333 13.556 11.8855 13.556 11.3333V8.44431C13.556 7.89202 13.1083 7.44431 12.556 7.44431H12.1116C11.5593 7.44431 11.1116 7.89202 11.1116 8.44431V11.3333C11.1116 11.8855 11.5593 12.3333 12.1116 12.3333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7781 15.3888H16.2226C16.7748 15.3888 17.2226 14.9411 17.2226 14.3888V8.44431C17.2226 7.89202 16.7748 7.44431 16.2226 7.44431H15.7781C15.2258 7.44431 14.7781 7.89202 14.7781 8.4443V14.3888C14.7781 14.9411 15.2258 15.3888 15.7781 15.3888Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBoard);
export default __webpack_public_path__ + "static/media/view_board.a0744083.svg";
export { ForwardRef as ReactComponent };